const validate = values => {

  const errors = {}

  if (!values.metaTitle) {
    errors.metaTitle = 'Meta Title is Required';
  } else if(values.metaTitle.trim() == ''){
    errors.metaTitle = 'Meta Title is Required';
  }

  if (!values.metaDescription) {
    errors.metaDescription = 'Meta Description is Required';
  } else if(values.metaDescription.trim() == ''){
    errors.metaDescription = 'Meta Description is Required';
  }


  if(!values.footerCategory) {
    errors.footerCategory = 'Please choose Footer Category';
  }

  if (!values.pageUrl) {
    errors.pageUrl = 'Page URL is Required';
  } else if(values.pageUrl .trim() == ''){
    errors.pageUrl = 'Page URL is Required';
  }else {
    var slashCount = (values.pageUrl.match(/\//g) || []).length;
    var questionCount = (values.pageUrl.match(/\?/g) || []).length;
    var andCount = (values.pageUrl.match(/\&/g) || []).length;
    if (slashCount >= 1 || questionCount >= 1 || andCount >= 1) {
      errors.pageUrl = 'Invalid Page URL';
    }
  }

  if (!values.pageTitle) {
    errors.pageTitle = 'Page Title is Required';
  } else if(values.pageTitle.trim() == ''){
    errors.pageTitle = 'Page Title is Required';
  }

  if (!values.content) {
    errors.content = 'Blog Content is Required';
  } else if(values.content.trim() == ''){
    errors.content = 'Blog Content is Required';
  }

  return errors
}

export default validate
